import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=62ffe620&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=ts"
export * from "./collapse.vue?vue&type=script&lang=ts"
import style0 from "./collapse.vue?vue&type=style&index=0&id=62ffe620&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ffe620",
  null
  
)

export default component.exports